export function addClasses(node, ...classes) {
    if (classes.length > 0) {
        node === null || node === void 0 ? void 0 : node.classList.add(...classes);
    }
}
export function parseClassList(list) {
    if (!list) {
        return [];
    }
    return list
        .split(" ")
        .map((s) => s.trim())
        .filter((s) => s.length);
}
export function removeClasses(node, ...classes) {
    if (classes.length > 0) {
        node === null || node === void 0 ? void 0 : node.classList.remove(...classes);
    }
}
